"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getOrderPaymentMethodId = exports.isOrderInUsableTransactionState = exports.isOrderPaymentOpen = exports.isOrderPaymentInProgress = exports.isOrderPaymentFailed = exports.isOrderPaymentCanceled = exports.isOrderPaymentPaid = exports.getCurrentOrderPaymentMethod = void 0;
const array_1 = require("../../common/js/helper/array");
const OrderTransactionStates_1 = __importDefault(require("../enums/OrderTransactionStates"));
const PAID_TRANSACTION_STATES = [
    OrderTransactionStates_1.default.paid,
    OrderTransactionStates_1.default.authorized,
];
const CANCELLED_TRANSACTION_STATES = [OrderTransactionStates_1.default.cancelled];
const FAILED_TRANSACTION_STATES = [OrderTransactionStates_1.default.failed];
const IN_PROGRESS_TRANSACTION_STATES = [OrderTransactionStates_1.default.inProgress];
const OPEN_PAYMENT_STATES = [OrderTransactionStates_1.default.open];
const getOrderActiveTransaction = (order) => {
    const orderTransaction = order.transactions?.find((transaction) => transaction.stateMachineState?.technicalName &&
        CANCELLED_TRANSACTION_STATES.includes(transaction.stateMachineState.technicalName));
    if (!orderTransaction) {
        return (0, array_1.last)(order.transactions ?? []) ?? null;
    }
    return orderTransaction;
};
const getOrderPaymentState = (order) => getOrderActiveTransaction(order)?.stateMachineState?.technicalName ?? null;
const isOrderInPaymentStateArray = (order, paymentStates) => {
    const paymentState = getOrderPaymentState(order);
    if (!paymentState) {
        return false;
    }
    return paymentStates.includes(paymentState);
};
const getCurrentOrderPaymentMethod = (order) => getOrderActiveTransaction(order)?.paymentMethod ?? null;
exports.getCurrentOrderPaymentMethod = getCurrentOrderPaymentMethod;
const isOrderPaymentPaid = (order) => isOrderInPaymentStateArray(order, PAID_TRANSACTION_STATES);
exports.isOrderPaymentPaid = isOrderPaymentPaid;
const isOrderPaymentCanceled = (order) => isOrderInPaymentStateArray(order, CANCELLED_TRANSACTION_STATES);
exports.isOrderPaymentCanceled = isOrderPaymentCanceled;
const isOrderPaymentFailed = (order) => isOrderInPaymentStateArray(order, FAILED_TRANSACTION_STATES);
exports.isOrderPaymentFailed = isOrderPaymentFailed;
const isOrderPaymentInProgress = (order) => isOrderInPaymentStateArray(order, IN_PROGRESS_TRANSACTION_STATES);
exports.isOrderPaymentInProgress = isOrderPaymentInProgress;
const isOrderPaymentOpen = (order) => isOrderInPaymentStateArray(order, OPEN_PAYMENT_STATES);
exports.isOrderPaymentOpen = isOrderPaymentOpen;
const isOrderInUsableTransactionState = (order) => (0, exports.isOrderPaymentPaid)(order) ||
    (0, exports.isOrderPaymentCanceled)(order) ||
    (0, exports.isOrderPaymentFailed)(order) ||
    (0, exports.isOrderPaymentInProgress)(order);
exports.isOrderInUsableTransactionState = isOrderInUsableTransactionState;
const getOrderPaymentMethodId = (order) => {
    const transaction = getOrderActiveTransaction(order);
    if (!transaction) {
        return null;
    }
    return transaction.paymentMethodId;
};
exports.getOrderPaymentMethodId = getOrderPaymentMethodId;
